import React from 'react'
import { CardsWidget7 } from '../../../../../../_metronic/partials/widgets'
import { CardsWidget20 } from '../../../../../../_metronic/partials/widgets'
import { CardsWidget17 } from '../../../../../../_metronic/partials/widgets'
import { ListsWidget26 } from '../../../../../../_metronic/partials/widgets'
import { FeedsWidget6 } from '../../../../../../_metronic/partials/widgets'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import PropertyCarousel from './Sc'
import { useState, useEffect } from 'react'
// import { MixedWidget10C } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10C'
import { MixedWidget10CS } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10Sponsor'
import { MixedWidgetSponsor } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidgetSponsor'

import { ChartsWidgetG2 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidgetG2'
import { ChartsWidget12 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget12'
import ImageCarousel from './SponCr'
// import ImageCarousel from './SponCr'
import ImpactHubCarousel from './SponImgC'
import { TablesWidget9 } from '../../../../../../_metronic/partials/widgets'
import MapComponentC from '../Map copy'
import StatsCard from './StatsCard'
import PerformanceWidget from './Performancewidgetlive '
import NFTLayout from './Nftlayout '
import { useQuery } from 'react-query'
// import ProgressBar from './PBar'
import ProgressBar from './PBar'
import axios from 'axios'

import StatsCard2 from './StatsCards2'

interface CommitmentsData {
  sponsors: number;
  commitments: number;
  totalQuantity: number;
  overDue: number;
  completed: number;
  balance: number;
  overdueQuantity: number;
  completedQuantity: number;
  monthWiseCreated: Record<string, number>;
  monthWiseCompleted: Record<string, number>;
  lifeImpacted: number;
  collectVsRecyclePiechart: Record<string, number>;
  enviournmentWisePiechart: Record<string, number>;
  supplyChainWiseDataList: Array<{
    supplyChainId: string;
    supplyChainName: string;
    totalCommitments: number;
    totalCompletedCommitments: number;
    recyclePercentage: number;
    collectPercentage: number;
  }>;
  countryWiseQuantity: Record<string, number>;
  countryWiseCompletedQuantity: Record<string, number>;
}

interface TeamMember {
  customerName: string;
  address: string;
  profile: string;
  quantity: number;
  joiningDate: string;
  description: string;
}

interface SponsorData {
  id: string;
  social: Array<{
    linkedIn: string;
    twitter: string;
    facebook: string;
    website: string;
    ytVideo: string;
  }>;
  team: TeamMember[];
  facilityList: Array<{
    pickupPointName: string;
    address: string;
    images: string[];
    description: string;
  }>;
  images: Array<{
    url: string;
    description: string;
  }>;
  videos: any[];
  createdBy: string;
  createdByName: string;
  sponsorId: string;
  sponsorName: string;
  date: string;
}

interface ApiResponse {
  data: SponsorData[];
  totalStock: number;
}


const SponsorDash = () => {

  const [data, setData] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState(true)

  const [fulfillmentData, setFulfillmentData] = useState<any>(null);
  useEffect(() => {
    const fetchFulfillmentData = async () => {
      try {
        const authData = localStorage.getItem('kt-auth-react-v')
        if (!authData) {
          console.error('No auth data found in localStorage')
          return
        }

        const parsedAuthData = JSON.parse(authData)
        const token = parsedAuthData?.data?.token
        const sponsorId = parsedAuthData?.data?.userId

        if (!token || !sponsorId) {
          console.error('No token or sponsorId found in auth data')
          return
        }

        const response = await fetch(
          `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/fulfillments`,
          {
            method: 'GET',
            headers: {
              'Authorization': token,
              'sponsor': sponsorId,
              'Content-Type': 'application/json'
            }
          }
        )

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const result = await response.json()
        setFulfillmentData(result)
      } catch (error) {
        console.error('Error fetching fulfillment data:', error)
      }
    }

    fetchFulfillmentData()
  }, [])


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Get token from localStorage
  //       const authData = localStorage.getItem('kt-auth-react-v')
  //       const token = authData ? JSON.parse(authData).data.token : null

  //       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}engagement`, {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         }
  //       })
  //       const result = await response.json()
  //       setData(result.data || result || [])
  //       setLoading(false)
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //       setLoading(false)
  //     }
  //   }

  //   fetchData()
  // }, [])




  // Add state for commitments data
  const [commitmentsData, setCommitmentsData] = useState<CommitmentsData | null>(null);

  // Update the callCommitmentsAPI function to set the data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get token from localStorage
        const authData = localStorage.getItem('kt-auth-react-v')
        const token = authData ? JSON.parse(authData).data.token : null

        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}engagement`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        const result = await response.json()
        setData(result.data || result || [])
        setLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false)
      }
    }

    const callCommitmentsAPI = async () => {
      try {
        // Get token from localStorage
        const authData = localStorage.getItem('kt-auth-react-v')
        if (!authData) {
          console.error('No auth data found in localStorage')
          return
        }
        const parsedAuthData = JSON.parse(authData)
        const token = parsedAuthData?.data?.token
        if (!token) {
          console.error('No token found in auth data')
          return
        }
        // Call the API
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}commitments/analytics`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        setCommitmentsData(data) // Set the response data
        return data
      } catch (error) {
        console.error('Error calling commitments API:', error)
      }
    }

    // Call both functions
    fetchData()
    callCommitmentsAPI()
  }, [])

  // callCommitmentsAPI()

  // const mapData = data?.[0]?.facilityList?.map(facility => ({
  //   id: facility.pickupPointId,
  //   name: facility.pickupPointName,
  //   position: {
  //     lat: facility.latitute,
  //     lng: facility.longitute
  //   },
  //   address: facility.address,
  //   image: facility.images?.[0],
  //   description: facility.description,
  //   isCustomer: false
  // })) || [];





  const dummyData = [
    {
      customerId: "1",
      customerName: "John Doe",
      address: "123 Main St",
      profile: "HOUSEHOLD",
      profileImage: "https://via.placeholder.com/400x400?text=John",
      quantity: 1500,
      joiningDate: "2025-01-15T10:30:00.000+00:00",
      description: "Active contributor to sustainability"
    },
    {
      customerId: "2",
      customerName: "Jane Smith",
      address: "456 Oak Ave",
      profile: "WASTE_PICKER",
      profileImage: "https://via.placeholder.com/400x400?text=Jane",
      quantity: 2300,
      joiningDate: "2025-02-20T14:45:00.000+00:00",
      description: "Dedicated waste management specialist"
    },
    {
      customerId: "3",
      customerName: "Mike Johnson",
      address: "789 Pine Rd",
      profile: "CLEANUP",
      profileImage: "https://via.placeholder.com/400x400?text=Mike",
      quantity: 890,
      joiningDate: "2025-03-10T09:15:00.000+00:00",
      description: "Community cleanup organizer"
    }
  ];


  //   const mapData = fulfillmentData?.data?.[0]?.pickupPointBreakup?.map((point: any) => ({
  //     id: point.pickupPointId,
  //     name: point.pickupPointName,
  //     position: {
  //       lat: point.address?.latitute,
  //       lng: point.address?.longitute
  //     },
  //     address: point.address?.street,
  //     image: point.address?.country,
  //     description: `${point.customerCount} Customers, ${point.quantity} kg`,
  //     isCustomer: false
  //   })) || [];

  // const customerMapData = fulfillmentData?.data?.[0]?.customerBreakup?.map((customer: any) => ({
  //   id: customer.customerId,
  //   name: customer.customerName,
  //   position: {
  //     lat: customer.address?.latitute,
  //     lng: customer.address?.longitute
  //   },
  //   address: customer.address?.street,
  //   image: customer.profile?.[0]?.docUrl,
  //   description: `${customer.quantity} kg collected`,
  //   isCustomer: true,
  //   kycDocument: customer.profile,  // This already has the correct structure
  //   mobile: customer.pickupPointName,
  //   totalDepositedQuantity: customer.quantity
  // })) || [];
  // const combinedMapData = [...mapData, ...customerMapData];

  // CORRECTED CODE - Replace the map data extraction section

  // Pickup Point Data
  const mapData = fulfillmentData?.data?.[0]?.pickupPointBreakup?.map((point: any) => ({
    id: point.pickupPointId,
    name: point.pickupPointName,
    position: {
      lat: point.address?.latitute,
      lng: point.address?.longitute
    },
    address: point.address?.street,
    image: point.address?.country,
    description: `${point.customerCount} Customers, ${point.quantity} kg`,
    isCustomer: false
  })) || [];

  // Customer Data - FIXED VERSION
  // Flatten all customers from all pickup points
  const customerMapData = fulfillmentData?.data?.[0]?.pickupPointBreakup
    ?.flatMap((point: any) =>
      point.customerBreakup?.map((customer: any) => ({
        id: customer.customerId,
        name: customer.customerName,
        position: {
          lat: customer.address?.latitute,
          lng: customer.address?.longitute
        },
        address: customer.address?.street,
        image: customer.profile?.[0]?.docUrl,
        description: `${customer.quantity} kg collected`,
        isCustomer: true,
        kycDocument: customer.profile,
        mobile: customer.pickupPointName,
        totalDepositedQuantity: customer.quantity,
        customerType: customer.customerType
      }))
        // Filter out entries with invalid coordinates (0,0)
        .filter((customer: any) =>
          customer.position.lat !== 0 && customer.position.lng !== 0
        )
    ) || [];

  const combinedMapData = [...mapData, ...customerMapData];
  return (
    // <div className='row'>
    //     <div className='col-xxl-6'>
    //         <div className='row g-5'>
    //             <div className='col-md-6'>
    //                 <CardsWidget20
    //                     className='card-xl-stretch mb-xl-8'
    //                     description={'Purchase Orders'}
    //                     color='#F1416C'
    //                     img={toAbsoluteUrl('/media/patterns/vector-1.png')}
    //                 />
    //             </div>
    //             <div className='col-md-6'>
    //                 <CardsWidget17
    //                     className='card-xl-stretch mb-xl-8'
    //                     chartSize={80}
    //                     chartLine={15}
    //                     chartRotate={180}
    //                 />
    //             </div>
    //             <div className='col-md-6'>


    //                 <CardsWidget7
    //                     className='card-xl-stretch mb-xl-8'
    //                     description='Material Sales (kgs)'
    //                     icon={false}
    //                     stats={4500}
    //                     labelColor='primary'
    //                     textColor='light'
    //                 />
    //             </div>
    //             <div className='col-md-6'>
    //                 <ListsWidget26 className='card-xl-stretch mb-xl-8' />
    //             </div>
    //         </div>
    //     </div>

    //     {/* Right half: FeedsWidget6 */}
    //     <div className='col-xxl-6'>
    //         <FeedsWidget6 className='' />
    //     </div>
    // </div>

    <>
      {/* <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <CardsWidget20
            className='h-md-50 mb-5 mb-xl-10'
            description={"Purchase Orders"}
            color='#F1416C'
            data={commitmentsData?.commitments || 0}
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
          <CardsWidget7
            className='h-md-50 mb-5 mb-xl-10'
            description='Lives Impacted'
            //   heroesTitle="PFC Heros"
            icon={false}
            stats={parseFloat((commitmentsData?.lifeImpacted || 0).toFixed(2))}
            labelColor='dark'
            textColor='gray-300'
          />
        </div>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <CardsWidget17
            className="h-md-100"
            collectionValue={commitmentsData?.completed?.toString() || "0"}
            recyclingValue={commitmentsData?.balance?.toString() || "0"}
            // collection={commitmentsData?.collectVsRecyclePiechart.RECYCLE || 0}
            // recycling={commitmentsData?.collectVsRecyclePiechart.COLLECT || 0}
            collection={commitmentsData?.collectVsRecyclePiechart?.RECYCLE || 0}
            recycling={commitmentsData?.collectVsRecyclePiechart?.COLLECT || 0}
          />

        </div>
        <div className='col-xxl-6 d-flex flex-column h-100'>
          <FeedsWidget6 className='h-100' />
        </div>
      </div> */}



      <div
        style={{
          backgroundColor: '#ffffff',
          backgroundImage: `url('/banner.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          padding: '20px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}
      >
        {/* Left Side - Title and Logo */}



        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ fontSize: '20px', color: '#FFF', fontWeight: '700' }}>
            Membership tier
          </div>

          {/* Logo */}
          <div
            style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: '2px solid #f0f0f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f8f9fa'
            }}
          >
            <img
              src={fulfillmentData?.data?.[0]?.packageInfo?.packageLogo}
              alt='Logo'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div style={{ fontSize: '20px', color: '#FFF', fontWeight: '700' }}>
            {fulfillmentData?.data?.[0]?.packageInfo?.packageName}
          </div>
        </div>

        {/* Right Side - Dates */}
        <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
          {/* Start date */}
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '12px', color: '#000000', fontWeight: '500', marginBottom: '4px' }}>
              Start date
            </div>
            <div style={{ fontSize: '16px', color: '#000000', fontWeight: '600' }}>
              {new Date(fulfillmentData?.data?.[0]?.startDate).toLocaleDateString('en-GB')}
            </div>
          </div>

          {/* Renewal date */}
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '12px', color: '#000000', fontWeight: '500', marginBottom: '4px' }}>
              Renewal date
            </div>
            <div style={{ fontSize: '16px', color: '#000000', fontWeight: '600' }}>
              {new Date(fulfillmentData?.data?.[0]?.endDate).toLocaleDateString('en-GB')}
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '30px', marginBottom: '' }}>
        <div style={{ flex: 1, border: "" }}>
          {/* {fulfillmentData && fulfillmentData.data && fulfillmentData.data.length > 0 ? (
            <StatsCard
  img={toAbsoluteUrl('/media/patterns/vector-1.png')}
  targetCustomerCount={fulfillmentData.data[0].targetCustomerCount}
  actualCustomerCount={fulfillmentData.data[0].actualCustomerCount}
  targetQty={fulfillmentData.data[0].targetQty}
  monthWiseCollected={fulfillmentData.data[0].monthWiseCollected}
  householdpercentage={fulfillmentData?.data[0]?.fulfilledCustomerPercentage || 0}
  plasticpercentage={fulfillmentData?.data[0]?.fulfilledQuantityPercentage || 0}
/>
          ) : (
            <StatsCard img={toAbsoluteUrl('/media/patterns/vector-1.png')} />
          )} */}

          {fulfillmentData && fulfillmentData.data && fulfillmentData.data.length > 0 ? (
            //   <StatsCard
            //     img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            //    targetCustomerCount={fulfillmentData.data?.[0]?.targetCustomerCount}
            // actualCustomerCount={fulfillmentData.data?.[0]?.actualCustomerCount}
            // targetQty={fulfillmentData.data?.[0]?.targetQty}
            // monthWiseCollected={fulfillmentData.data?.[0]?.monthWiseCollected}
            //     householdpercentage={fulfillmentData?.data?.[0]?.fulfilledCustomerPercentage || 0}
            //     plasticpercentage={fulfillmentData?.data?.[0]?.fulfilledQuantityPercentage || 0}

            //   />



            <StatsCard
              img={toAbsoluteUrl('/media/patterns/vector-1.png')}
              targetCustomerCount={fulfillmentData.data?.[0]?.targetCustomerCount}
              actualCustomerCount={fulfillmentData.data?.[0]?.actualCustomerCount}
              targetQty={fulfillmentData.data?.[0]?.packageInfo?.plasticPrevented}
              monthWiseCollected={fulfillmentData.data?.[0]?.monthWiseCollected}
              householdpercentage={fulfillmentData?.data?.[0]?.fulfilledCustomerPercentage || 0}
              plasticpercentage={fulfillmentData?.data?.[0]?.fulfilledQuantityPercentage || 0}
              lastMonthCollected={fulfillmentData?.data?.[0]?.actualQty ?? 0}
            />
          ) : (
            <StatsCard img={toAbsoluteUrl('/media/patterns/vector-1.png')} />
          )}

        </div>
        <div style={{ flex: 1, border: "" }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
            <ChartsWidget12
              title="Target achievement"
              className='card-lg-stretch mb-xl-8'
              customersData={(() => {
                const commitment = fulfillmentData?.data?.[0]
                if (!commitment) return {}
                const allMonths = new Set([
                  ...Object.keys(commitment.cumulativeCustomerAdded || {}),
                  ...Object.keys(commitment.cumulativeCollected || {}),
                ])
                const sortedMonths = Array.from(allMonths).sort((a, b) => {
                  const [monthA, yearA] = a.split('/')
                  const [monthB, yearB] = b.split('/')
                  return yearA === yearB ? parseInt(monthA) - parseInt(monthB) : yearA.localeCompare(yearB)
                })
                const result: Record<string, number> = {}
                sortedMonths.forEach(month => {
                  result[month] = commitment.cumulativeCustomerAdded?.[month] || 0
                })
                return result
              })()}
              suppliersData={(() => {
                const commitment = fulfillmentData?.data?.[0]
                if (!commitment) return {}
                const allMonths = new Set([
                  ...Object.keys(commitment.cumulativeCustomerAdded || {}),
                  ...Object.keys(commitment.cumulativeCollected || {}),
                ])
                const sortedMonths = Array.from(allMonths).sort((a, b) => {
                  const [monthA, yearA] = a.split('/')
                  const [monthB, yearB] = b.split('/')
                  return yearA === yearB ? parseInt(monthA) - parseInt(monthB) : yearA.localeCompare(yearB)
                })
                const result: Record<string, number> = {}
                sortedMonths.forEach(month => {
                  result[month] = commitment.cumulativeCollected?.[month] || 0
                })
                return result
              })()}
            />


          </div>
        </div>
      </div>


      <div style={{ display: 'flex', gap: '30px', marginBottom: '20px' }}>
        {/* <div style={{ flex: 1, border: "" }}>
          <PerformanceWidget />
        </div> */}
        <div style={{ flex: 1, border: "" }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <MixedWidgetSponsor
                className=''
                chartColor='info'
                chartHeight='150px'
                title="Households connected"
                subtitle="New households added every month"
                amount={fulfillmentData?.data?.[0]?.actualCustomerCount}
                chartData={fulfillmentData?.data?.[0]?.monthWiseCustomerAdded || {}}
                seriesName='Households connected'
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <MixedWidgetSponsor
                amountSuffix="kg"
                className=''
                chartColor='info'
                chartHeight='150px'
                title="Plastic collected"
                subtitle="Plastic collected every month"
                // amount={
                //   fulfillmentData?.data?.[0]?.monthWiseCollected
                //     ? (Object.values(fulfillmentData.data[0].monthWiseCollected).pop() as number)?.toString() || "0"
                //     : "0"
                // }
                amount={String(fulfillmentData?.data?.[0]?.fulfilledQuantityPercentage ?? 0)}
                chartData={fulfillmentData?.data?.[0]?.monthWiseCollected || {}}
                seriesName='Plastic prevented'
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>


              <MixedWidgetSponsor
                className=''
                chartColor='info'
                chartHeight='150px'
                title="Household members impacted"
                subtitle="No of household members impacted every month"
                // amount="0"
                chartData={{}}
                seriesName='No Data'
                amount={String((fulfillmentData?.data?.[0]?.actualCustomerCount ?? 0) * 4)}
              />


            </div>
          </div>
        </div>
      </div>


      {/* <div>
        {data && data[0] && data[0].team && (
          <PropertyCarousel team={data[0].team} />
        )}
      </div> */}

      {/* <div className='row'>
        <div className='col-md-6'>
          <NFTLayout data={
            (data as any)?.flatMap((sponsor: any) => sponsor.team) || []
          } />
        </div>

        <div className='col-md-6'>
     
        </div>
      </div> */}





      {/* <TablesWidget9 className=''/> */}




      <div style={{ marginTop: "20px" }}>
        <MapComponentC data={combinedMapData} zooms={12} />
      </div>


      <div style={{ margin: "20px 0" }}>
        {/* <TablesWidget9 className='' data={{ supplyChainWiseDataList: fulfillmentData?.data?.[0]?.pickupPointBreakup || [] }} />
         */}

        <TablesWidget9
          className=''
          data={{ supplyChainWiseDataList: fulfillmentData?.data?.[0]?.pickupPointBreakup || [] }}
        />
      </div>




      <ImpactHubCarousel
        facilities={(data as any)?.[0]?.facilityList || []}
        onShowAll={() => console.log('Show all clicked')}
      />

      {/* <div style={{marginBottom:"20px"}}>
        <TablesWidget9 className='' data={commitmentsData} />
      </div> */}

      <ImageCarousel images={(data as any)?.[0]?.images || []} />



      <div className="card mb-5">
        <div className="card-body">
          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
            <p className="card-title mb-0" style={{ fontSize: '1.25rem', fontWeight: '600' }}>Follow us</p>
            <div className="d-flex" style={{ gap: '15px' }}>
              {(data as any)?.[0]?.social && (data as any)[0].social.length > 0 ? (
                Object.entries((data as any)[0].social[0]).map(([platform, url], index) => {
                  if (!url || url === "") return null;
                  let iconClass = '';
                  let color = '';

                  switch (platform.toLowerCase()) {
                    case 'linkedin':
                      iconClass = 'fab fa-linkedin';
                      color = '#0A66C2';
                      break;
                    case 'twitter':
                      iconClass = 'fab fa-twitter';
                      color = '#1DA1F2';
                      break;
                    case 'facebook':
                      iconClass = 'fab fa-facebook';
                      color = '#1877F2';
                      break;
                    case 'website':
                      iconClass = 'fas fa-globe';
                      color = '#34A853';
                      break;
                    case 'ytvideo':
                      iconClass = 'fab fa-youtube';
                      color = '#FF0000';
                      break;
                    default:
                      iconClass = 'fas fa-link';
                      color = '#666666';
                  }

                  return (
                    <div key={index} className="flex-shrink-0">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: '#f8f9fa',
                          border: '2px solid #e9ecef',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease'
                        }}
                        onClick={() => window.open(url as string, '_blank')}
                        title={`Visit our ${platform}`}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#e9ecef';
                          e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                          e.currentTarget.style.transform = 'scale(1)';
                        }}
                      >
                        <i className={`${iconClass} fs-5`} style={{ color: color }}></i>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-dark mb-0">No social links available</p>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export { SponsorDash }
